export const MOCK_USER = {
  access_token: "991797:5159159598c8f65463782435932b8237",
  ownerInfo: {
    company_name: "DEV: ООО «Тестовая компания»",
  },
};

export const MOCK_TARIFFS = [
  {
    key: "minimal",
    name: "Минимальный",
    pricePerCashdesk: 100000,
    active: true,
    comingSoon: false,
    features: ["Фискализация", "Маркировка", "ИКПУ"],
  },
  {
    key: "optimal",
    name: "Оптимальный",
    pricePerCashdesk: null,
    active: false,
    comingSoon: true,
    features: ["Всё из Минимального", "Аналитика продаж", "Отчёты"],
  },
  {
    key: "premium",
    name: "Премиум",
    pricePerCashdesk: null,
    active: false,
    comingSoon: true,
    features: ["Всё из Оптимального", "API-доступ", "Приоритетная поддержка"],
  },
];
